
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 96","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"30.25","y":"12.25","width":"35.5","height":"21.5","rx":"3.25","fill":"currentColor","fill-opacity":".16","stroke":"currentColor","stroke-width":"2.5"}}),_c('rect',{attrs:{"x":"11.25","y":"33.25","width":"73.5","height":"31.5","rx":"7.75","fill":"currentColor","fill-opacity":".07","stroke":"currentColor","stroke-width":"2.5"}}),_c('circle',{attrs:{"cx":"24","cy":"44","r":"3.5","fill":"currentColor","fill-opacity":".45"}}),_c('path',{attrs:{"d":"M30.25 64.25h35.5v10.5a5 5 0 01-5 5h-25.5a5 5 0 01-5-5v-10.5z","fill":"currentColor","fill-opacity":".07","stroke":"currentColor","stroke-width":"2.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M39 71h18","stroke":"currentColor","stroke-width":"2.5","stroke-linecap":"round","opacity":".4"}})])
          )
        }
      }
    